import { useLocalSearchParams } from "expo-router";
import useSessionStore from "./useSessionStore";

const useCurrentSession = () => {
	const sessionItems = useSessionStore((state) => state.sessionItems);
	const currentBlockIndex = useSessionStore((state) => state.currentBlockIndex);
	const { index } = useLocalSearchParams<{
		index: string;
	}>();

	const currentItemIndex = index ? Number.parseInt(index) - 1 : 0;

	const currentBlock = sessionItems?.length
		? sessionItems[currentBlockIndex]
		: [];

	const currentItem = currentBlock[currentItemIndex];
	const numSessionItems = sessionItems?.length ?? 0;

	const numTotalItems = sessionItems?.reduce((acc, curr) => {
		return acc + curr.length;
	}, 0);

	return {
		currentBlock,
		currentItem,
		currentBlockIndex,
		currentItemIndex,
		numSessionItems,
		numTotalItems,
	};
};

export default useCurrentSession;
